export const clickOutside = {
	beforeMount: function (el, binding) {

		const bubble = binding.modifiers.bubble;

		const handlerClick = e => {
			let excluded = false;
			if (e.target.dataset.exclude) excluded = true;
			if (bubble || !excluded && (!el.contains(e.target) && el !== e.target)) {
				binding.value(e);
			}
		};
		const handlerKeyup = (event) => {
			if (event.key == "Escape") {
				binding.value(event);
			}
		};
		el.vueClickOutside = handlerClick;
		el.vueKeyupEscape = handlerKeyup;

		document.addEventListener("click", handlerClick);
		document.addEventListener("keyup", handlerKeyup);
	},
	unmounted: function (el) {
		document.removeEventListener("click", el.vueClickOutside);
		document.removeEventListener("keyup", el.vueKeyupEscape);
	}
}